import {Presenter} from '../../../../Support/with_presenter';
import {ReportService} from '../../../../Network/ReportService';
import {NetworkRequestStatus} from '../../../../Network/NetworkResult';
import {ReportType} from '../../../../Models/ReportType';

export class CreateReportPresenter implements Presenter {
    public name: string = '';
    public description: string = '';
    public type: ReportType = ReportType.TREND;

    public disabled: boolean = true;

    public storing = false;

    constructor(private reportService: ReportService) {}

    public mount(): void {
        /* Noop */
    }

    public unmount(): void {
        /* Noop */
    }

    public onNameChange(name: string): void {
        this.name = name;
        this.checkValid();
    }

    public onDescriptionChange(description: string): void {
        this.description = description;
        this.checkValid()
    }

    public onTypeChange(type: ReportType): void {
        this.type = type;
    }

    public checkValid(): void {
        this.disabled = (this.name === '') || (this.description === '');
    }

    public async store(): Promise<void> {
        try {
            this.storing = true;
            const result = await this.reportService.createWithType(this.name, this.description, this.type);
            if (result.status === NetworkRequestStatus.Success) {
                window.location.href = `/reports/${result.data.id}`;
            }
        } finally {
            this.storing = false;
        }
    }
}
